// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
.announcement-filter-container {
  position: absolute;
  right: 20px;
  bottom: 20px;
  left: auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  color: #9dbcda;
}

.announcementfilter-flex-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.filter-component-container {
  color: #9dbcda;
}

.increment-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 40px;
  width: 72px;
  padding: 0 2px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: #3b5873;
  transition: background-color 120ms ease, border-color 120ms ease;
}
@media (max-width: 599px) {
  .increment-btn {
    display: none;
  }
}
.increment-btn:hover {
  background: rgb(25.8498985801%, 38.5557809331%, 50.3853955375%);
  border-color: rgba(157, 188, 218, 0.25);
}
.increment-btn .btn-divider {
  width: 1px;
  height: 18px;
  background: rgba(255, 255, 255, 0.25);
  flex-shrink: 0;
}
.increment-btn button {
  width: 34px;
  height: 36px;
  padding: 0;
  background: transparent;
  border: none;
  color: #ffffff;
  border-radius: 6px;
  box-shadow: none;
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer;
  transition: background-color 120ms ease;
}
.increment-btn button:hover {
  background: rgba(255, 255, 255, 0.12);
}
.increment-btn button:focus {
  box-shadow: none;
}
.increment-btn button:focus-visible {
  outline: 2px solid #52aaff;
  outline-offset: 1px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
